import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56624d85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"flex":"1","display":"flex","justify-content":"center","align-items":"center","flex-direction":"column"} }

import api from '@/api/api'
import { ElMessage, ElUpload, emitChangeFn } from 'element-plus'

import { NewProfileStore } from '@/store/newProfileStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateMethod',
  emits: ['selected'],
  setup(__props, { emit: __emit }) {

const store = new NewProfileStore()

const emit = __emit

const OnUpload = async (options: any) => {
  const { file, onSuccess, onError } = options
  console.log(file)
  const formData = new FormData()
  formData.append('file', file)

  try {
    const response = await api.post('/profile/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    const profile = response.data.data
    store.Upload(profile)
    emit('selected')
  } catch (error:any) {
    onError(error)
    ElMessage.error('Unable to upload profile: ' + error.response?.data.message)
  }
}

const OnCreateNew = () => {
  store.New()
  emit('selected')
}

return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElRow = _resolveComponent("ElRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElButton, {
          type: "primary",
          size: "large",
          style: {"width":"400px"},
          onClick: OnCreateNew
        }, {
          default: _withCtx(() => [
            _createTextVNode("Create New")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_unref(ElUpload), {
          ref: "uploadRef",
          "auto-upload": true,
          action: "/upload",
          "show-file-list": false,
          "http-request": OnUpload
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ElButton, {
              type: "primary",
              size: "large",
              style: {"width":"400px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("Upload")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }),
    _createVNode(_component_ElRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_ElButton, {
          type: "primary",
          size: "large",
          style: {"width":"400px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode("Duplicate from an Existing Profile")
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})